import {
  TextInput as TextInputMantine,
  Button as ButtonMantine,
  Group as GroupMantine,
  Title as TitleMantine,
  Box as BoxMantine,
  PasswordInput as PasswordInputMantine,
  Checkbox as CheckboxMantine
} from '@mantine/core'
import styled, { css } from 'styled-components'


export const Group = styled(GroupMantine)`
  width: 100%;
`

export const Box = styled(BoxMantine)`
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
  z-index: 1;
`

export const Input = styled(TextInputMantine)`
  width: 100%;
  .mantine-TextInput-input {
    color: #ffffff !important;
    background-color: transparent !important;
    text-decoration: none !important;

    &:-webkit-autofill {
      transition: background-color 9999s ease-in-out 0s;
      -webkit-text-fill-color: #ffffff !important;
      caret-color: #ffffff;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      box-shadow: 0 0 0px 1000px transparent inset !important;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
      -webkit-text-fill-color: white !important;
    }
  }

  .mantine-TextInput-description {
    color: #828282 !important;
  }

  .mantine-Input-input:focus-within {
    border: 1px solid #37b1c9 !important;
  }
  .mantine-InputWrapper-label {
    color: #ffffff !important;
    margin-bottom: 0px !important;
  }
`

export const PasswordInput = styled(PasswordInputMantine)`
  width: 100%;
  .mantine-PasswordInput-input {
    background-color: transparent !important;
  }
  .mantine-PasswordInput-innerInput {
    color: #ffffff !important;

    &:-webkit-autofill {
      transition: background-color 9999s ease-in-out 0s;
      -webkit-text-fill-color: #ffffff !important;
      caret-color: #ffffff;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      box-shadow: 0 0 0px 1000px transparent inset !important;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
      -webkit-text-fill-color: white !important;
    }
  }
  .mantine-Input-input:focus-within {
    border: 1px solid #37b1c9 !important;
  }
  .mantine-InputWrapper-label {
    color: #ffffff !important;
    margin-bottom: 0px !important;
  }
`

export const Button = styled(ButtonMantine)`
  background-color: #e92177 !important;
`
export const Title = styled(TitleMantine)`
  color: #ffffff !important;
  font-size: ${({ fontSize }) => fontSize || '20px'}!important;
  text-align: center;
  margin-bottom: 20px !important;
  padding: 0 40px;
  max-width: ${({ maxWidth }) => maxWidth || ' 800px'};

  @media (max-width: 768px) {
    font-size: 20px !important;
  }
`

export const Paragraph = styled.p`
  color: #ffffff !important;
  font-size: 14px !important;
  padding: 0 40px;
  text-align: center;
  max-width: 800px;
`

export const ParagraphStrong = styled.p`
  color: #ffffff !important;
  font-size: 20px !important;
  padding: 0 50px;
  text-align: center;
  max-width: 1050px;
  font-weight: bold;
`

export const Paragraph2 = styled.p`
  color: #ffffff !important;
  font-size: 1.3rem !important;
  padding: 0 50px;
  text-align: center;
  max-width: 1200px;
`
export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 100px;
  padding-left: 15px;
  padding-right: 15px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  justify-content: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  background-color: #081f2d;
  background-image:
    radial-gradient(
      ellipse 50% 90% at top left,
      rgba(55, 177, 201, 0.6) 25%,
      rgba(55, 177, 201, 0.2) 60%,
      transparent 100%
    ),
    radial-gradient(
      ellipse 50% 90% at bottom right,
      rgba(233, 33, 119, 0.6) 1%,
      rgba(233, 33, 119, 0.2) 40%,
      transparent 100%
    );
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 1200px) {
    background-image:
      radial-gradient(
        ellipse 60% 70% at top left,
        rgba(55, 177, 201, 0.6) 25%,
        rgba(55, 177, 201, 0.2) 60%,
        transparent 100%
      ),
      radial-gradient(
        ellipse 60% 70% at bottom right,
        rgba(233, 33, 119, 0.6) 1%,
        rgba(233, 33, 119, 0.2) 40%,
        transparent 100%
      );
  }
  @media (max-width: 720px) {
    padding-top: 20px;
    background-image:
      radial-gradient(
        ellipse 70% 40% at top left,
        rgba(55, 177, 201, 0.6) 25%,
        rgba(55, 177, 201, 0.2) 60%,
        transparent 130%
      ),
      radial-gradient(
        ellipse 70% 40% at bottom right,
        rgba(233, 33, 119, 0.6) 1%,
        rgba(233, 33, 119, 0.2) 40%,
        transparent 130%
      );
  }

  @media (max-width: 500px) {
    justify-content: flex-start;
  }
`

export const MensagensErroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 8px;
`

export const TituloMensagem = styled.span`
  font-size: 16px;
  color: #ffffff;
`

export const ValidacoesWrapper = styled.div`
  display: grid;
  gap: 6px;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const CheckboxDescription = styled.p`
  font-size: 12px;
  color: #ffffff;
  font-family: Roboto;
  font-size: 12px;
  margin: 0;
`

export const Link = styled.a`
  color: #4dabf7;
`

export const Checkbox = styled(CheckboxMantine)`
  .mantine-Checkbox-input {
    background-color: transparent !important;
  }
  .mantine-Checkbox-label {
    color: #ffffff !important;
  }
  .mantine-InputWrapper-error {
    display: none;
  }
`

export const GrupoValidacao = styled.div`
  font-size: 16px;
  display: flex;
  gap: 8px;
  color: #ffffff;

  ${({ subGrupo }) =>
    subGrupo &&
    css`
      padding-left: 20px;
    `}

  p {
    margin: 0;
  }

  img {
    margin-top: 6px;
    width: 16px;
    height: 16px;
  }
`

export const Logo = styled.img`
  position: absolute;
  bottom: 3%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;

  @media (max-width: 500px) {
    display: none;
  }
  @media (max-height: 630px) {
    display: none;
  }
`

export const CustomInputLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 4px;
  width: 100%;

  .error-message {
    color: #f95252;
  }
`

export const CustomInputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const CustomPlaceholder = styled.span`
  color: ${({ error }) => (error ? '#F95252' : '#acb5bd')};
  font-size: 14px;
  position: absolute;
  left: 12px;
  bottom: 13%;
  pointer-events: none;
  opacity: ${(props) => (props.hasValue ? 0 : 1)};
`
